import deErrorIcon from '@shared/assets/icons/sets/de/error.svg';
import defaultErrorIcon from '@shared/assets/icons/sets/default/error.svg';
import { IconSetKey, resolveIconSetKey } from '@shared/components/Icon/iconSets/resolveIconSetKey.ts';
import { UserCountryCode } from '@shared/types/countryCodes.ts';
import { CountryAssetKeys } from '@shared/utils/resolveCountryAssetKey.ts';

const errorIconMap: Record<IconSetKey, string> = {
  [CountryAssetKeys.DEFAULT]: defaultErrorIcon,
  [CountryAssetKeys.DE]: deErrorIcon,
};

export function getErrorIconSrc(countryCode: UserCountryCode | null): string {
  return errorIconMap[resolveIconSetKey(countryCode)];
}
